import { ToggleButtonGroup, ToggleButton } from '@mui/material'
import type { FC } from 'react'
import type React from 'react'

export type DateFilterOption =
  | 'today'
  | 'this-week'
  | 'last-week'
  | 'this-month'
  | 'last-month'

type Props = {
  selected: DateFilterOption
  onChangeSelected: (option: DateFilterOption) => void
}

const DateFilters: FC<Props> = ({ selected, onChangeSelected }) => {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    selectedOption: DateFilterOption | null,
  ) => {
    if (selectedOption !== null) {
      onChangeSelected(selectedOption)
    }
  }

  return (
    <ToggleButtonGroup
      color="primary"
      value={selected}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      size="small"
    >
      <ToggleButton value="today">Today</ToggleButton>
      <ToggleButton value="this-week">This week</ToggleButton>
      <ToggleButton value="last-week">Last week</ToggleButton>
      <ToggleButton value="this-month">This month</ToggleButton>
      <ToggleButton value="last-month">Last month</ToggleButton>
    </ToggleButtonGroup>
  )
}

export default DateFilters
